import React from "react";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import brazing1 from "../Assets/Image/silver01.jpg";
import brazing2 from "../Assets/Image/silver-brazing-2.jpg";
import related1 from "../Assets/Image/tinned-copper-bar.jpg";
import related2 from "../Assets/Image/copper-laminated.jpg";
import related3 from "../Assets/Image/silver-bar.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const relatedProducts = [
  {
    name: "Tin/Silver Plated Copper Bars",
    image: related1,
    route: "/tin-silver-plated-copper-bars",
  },
  {
    name: "Copper Laminated Flexibles",
    image: related2,
    route: "/copper-laminated-flexibles",
  },
  {
    name: "Silver Flat Bars",
    image: related3,
    route: "/silver-flat-bars",
  },
];

const SilverBrazing = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Silver Brazing | Delta Engineering</title>
        <meta
          name="description"
          content="High-performance silver brazing solutions for electrical and industrial applications. Offering superior conductivity, corrosion resistance, and mechanical strength for switchgear, automotive, HVAC, aerospace, and more."
        />
        <meta
          name="keywords"
          content="Silver Brazing, Silver Brazing Process, Silver Brazing Applications, Electrical Contacts, Switchgear Brazing, Silver Alloy Brazing, Copper Silver Brazing, Brazed Joints, High Conductivity Brazing, Industrial Brazing Solutions"
        />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Silver Brazing | Delta Engineering"
        />
        <meta
          property="og:description"
          content="Precision-joined components using high-purity silver alloys. Superior electrical conductivity, corrosion resistance, and strength for demanding applications."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/silver-brazing"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/silver-brazing.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Silver Brazing | Delta Engineering"
        />
        <meta
          name="twitter:description"
          content="High-strength, conductive joints using advanced silver brazing alloys. Trusted for switchgear, HVAC, automotive, aerospace, and more."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/silver-brazing.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
          <Row className="justify-content-center">
            <Col lg={8} className="hero-content text-center">
              <h2
                className="hero-title"
                data-aos="zoom-in"
                data-aos-delay="300"
              >
                <span className="blue-text">Silver </span>{" "}
                <span className="white-text">Brazing</span>
              </h2>
              <p
                className="hero-subtitle"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                High-purity silver components for superior conductivity, thermal
                efficiency, and strength in demanding applications.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-3" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <div className="text-center mb-5">
            <h3 className="fw-bold section-title position-relative d-inline-block">
              Silver Brazing
              <span className="title-underline"></span>
            </h3>
            <p className="text-center text-muted mb-4">
              Our Silver Brazing solutions offer high-strength, conductive
              joints using advanced silver-based filler alloys. Ideal for
              electrical assemblies, switchgear, and precision connections, they
              ensure durability, corrosion resistance, and optimal performance
              under thermal and mechanical stress.
            </p>
          </div>

          <Row className="mb-5 align-items-center">
            <Col xs={12} md={6} className="mb-3 mb-md-0">
              <h4>Key Features</h4>
              <ul>
                <li>Busbar to Busbar Silver brazing</li>
                <li>Busbar to Flexible Silver brazing</li>
                <li>Flexible to flexible Silver brazing</li>
              </ul>
            </Col>
            <Col xs={12} md={6} className="text-center">
              <Image
                src={brazing1}
                alt="Silver Brazing Process"
                fluid
                rounded
                style={{
                  maxHeight: "300px",
                  width: "400px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </Col>
          </Row>

          <Row className="mb-5 align-items-center">
            <Col xs={12} md={6} className="text-center mb-3 mb-md-0">
              <Image
                src={brazing2}
                alt="Silver Brazing Application"
                fluid
                rounded
                style={{
                  maxHeight: "300px",
                  width: "400px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </Col>
            <Col xs={12} md={6}>
              <h4>Applications</h4>
              <ul>
                <li>Electrical contacts and switchgear assemblies</li>
                <li>Locomotive Copper connections</li>
                <li>Automotive components</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SilverBrazing;
